import Vue from 'vue'
import Router from 'vue-router'


Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    //主页
    {
      path: '/',
      name: 'index',
      component: () => import("./views/card/xinXunIndex.vue"),
      meta: {
        title: '设备管理',
      }
    },
    {
      path: '/card',
      component: () => import("./views/card/cardLayout.vue"),
      children: [
        {
          path: 'binding',
          name: 'binding',
          component: () => import("./views/card/binding.vue"),
        },{
          path: 'binding_v2',
          name: 'binding_v2',
          component: () => import("./views/card/binding_v2.vue"),
        }, {
          path: 'xinXunIndex',
          name: 'xinXunIndex',
          component: () => import("./views/card/xinXunIndex.vue"),
          
        }, {
          path: 'plan_list',
          name: 'plan_list',
          component: () => import("./views/card/plan_list.vue"),
          meta: {
            title: '套餐充值',
          }
        },{
          path: 'package_details',
          name: 'package_details',
          component: () => import("./views/card/packageDetails.vue"),
          meta: {
            title: '套餐详情',
          }
        },{
          path: 'recharge',
          name: 'recharge',
          component:()=>import("./views/card/recharge.vue"),
          meta: {
            title: '充值'
          }
        },{
          path: 'more_flow_plan',
          component:()=>import("./views/card/more_flow_plan.vue"),
          meta: {
            title: '加油包叠加对应套餐'
          }
        },{
          path: 'usage',
          name: 'usage',
          component: () => import("./views/card/usage.vue"),
          meta: {
            title: '卡信息',
          }
        }, {
          path: 'networkOptimization',
          name: 'networkOptimization',
          component: () => import("./views/card/networkOptimization.vue"),
          meta: {
            title: '切换网络',
          }
        }, {
          path: 'remoteControl',
          name: 'remoteControl',
          component: () => import("./views/card/remoteControl.vue"),
          meta: {
            title: '远程控制',
          }
        }, {
          path: 'coupon',
          name: 'coupon',
          component: () => import("./views/card/coupon.vue"),
          meta: {
            title: '卡券兑换',
          }
        }, {
          path:'balanceDes',
          component: ()=>import("./views/newUserCenter/balanceDes.vue"),
          meta: {
              title: '余额说明',
              KATarget: true
          }
        }, {
          path:'balanceLists',
          component: ()=>import("./views/newUserCenter/balanceLists.vue"),
          meta: {
              title: '我的余额',
          }
        }, {
          path:'nbalanceRecharge',
          component: ()=>import("./views/newUserCenter/balanceRecharge.vue"),
          meta: {
              title: '余额充值',
          }
        }, {
          path:'balanceResult',
          component: ()=>import("./views/newUserCenter/balanceResult.vue"),
          meta: {
              title: '支付结果',
          }
        }
      ]
    },
   
    //问题中心
    {
      path: '/question',
      name: 'question',
      component: () => import("./views/questionIndex.vue"),
      meta: {
        title: '问题中心',
      }
    },
    
    //绑定帐号
    {
      path:'/bindAccount',
      name:'bindAccount',
      component:()=>import("./views/bindAccount.vue"),
      meta: {
        title: '登录',
        login: false
      }
    },
    {
      path:'/realNameCourse',
      name:'realNameCourse',
      component:()=>import("./views/realNameCourse.vue"),
      meta: {
        title: '实名教程',
      }
    },
    {
      path:'/to_realName',
      name:'to_realName',
      component:()=>import("./views/to_realName.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path:'/to_realName_iframe',
      name:'to_realName_iframe',
      component:()=>import("./views/to_realName_iframe.vue"),
      meta: {
        title: '实名跳转',
        login: false
      }
    },
    {
      path: '/realName',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children: [
        {
          path:'index',
          name: 'realName',
          component: ()=>import("./views/realName/index.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'operatorName',
          name: 'operatorName',
          component: ()=>import("./views/realName/operatorName.vue"),
          meta: {
            login: false
          }
        }, {
          path: 'beforeSelect',
          name: 'beforeSelect',
          component: () => import("./views/realName/beforeSelect.vue"),
        },
      ]
    },
    
    //充值引导流程
    {
      path: '/process',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path: 'index',
          name: 'processIndex',
          component: ()=>import("./views/process/processIndex.vue"),
        },
        {
          path: 'plan',
          name: 'processPlan',
          component: ()=>import("./views/process/processPlan.vue"),
        },
      ]
    },
    //中间页
    {
      path: '/mifi',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path:'index',
          name: 'process',
          component: ()=>import("./views/middlePages/process.vue"),
          meta: {
            login: false
          }
        },
        {
          path:'authority',
          name: 'authority',
          component: ()=>import("./views/middlePages/authority.vue"),
          meta: {
            login: false
          }
        },
      ]
    },
    
    // 问题中心
    {
      path: '/question',
      component: ()=>import("./components/common/emptyLayout.vue"),
      children:[
        {
          path:'guardian',
          name: 'guardian',
          component: ()=>import("./views/question/guardian.vue"),
        }
      ]
    },
    {
      path: '*',
      // component:()=>import("./views/walkmanWifi.vue"),
    },

    // 金币签到个人中心
    {
      path: '/newUserCenter', 
      component: ()=>import('./components/common/emptyLayout.vue'),
      children: [
        {
          path: 'index',
          component: ()=>import('./views/newUserCenter/index.vue'),
          meta: {
            title: '个人中心'
          }
        },{
          path: 'myGold',
          component: ()=>import('./views/newUserCenter/myGold.vue'),
          meta: {
            title: '我的金币'
          }
        },{
          path: 'signInEveryDay',
          component: ()=>import('./views/newUserCenter/signInEveryDay.vue'),
          meta: {
            title: '天天签到领金币'
          }
        },{
          path: 'customerService',
          component: ()=>import('./views/newUserCenter/customerService.vue'),
          meta: {
            title: '客户服务'
          }
        },{
          path: 'mySetUp',
          component: ()=>import('./views/newUserCenter/mySetUp.vue'),
          meta: {
            title: '我的设置'
          }
        },{
          path: 'goldExchange',
          component: ()=>import('./views/newUserCenter/goldExchange.vue'),
          meta: {
            title: '金币兑换'
          }
        },{
          path: 'goodsDetails/:id',
          component: ()=>import('./views/newUserCenter/goodsDetails.vue'),
          meta: {
            title: '商品详情'
          }
        }, {
          path: 'orderFillIn/:id',
          component: ()=>import('./views/newUserCenter/orderFillIn.vue'),
          meta: {
            title: '订单填写'
          }
        },{
          path: 'goldLoot',
          component: ()=>import('./views/newUserCenter/goldLoot.vue'),
          meta: {
            title: '金币夺宝'
          }
        },{
          path: 'myPrize',
          component: ()=>import('./views/newUserCenter/myPrize.vue'),
          meta: {
            title: '我的奖品'
          }
        },{
          path: 'userMaterial',
          component: ()=>import('./views/newUserCenter/userMaterial.vue'),
          meta: {
            title: '个人资料'
          }
        },{
          path: 'recordQuery',
          component: ()=>import('./views/newUserCenter/recordQuery.vue'),
          meta: {
            title: '记录查询'
          }
        },{
          path: 'aboutUs',
          component: ()=>import('./views/newUserCenter/aboutUs.vue'),
          meta: {
            title: '关于我们'
          }
        }, {
          path: 'flowCouponUse/:id/:code',
          component: ()=>import('./views/newUserCenter/flowCouponUse.vue'),
          meta: {
            title: '奖品详情'
          }
        }, {
          path: 'prize_record_detail',
          component: ()=>import('./views/newUserCenter/prize_record_detail.vue'),
          meta: {
            title: '奖品详情'
          }
        }, {
          path: 'addressList',
          component: ()=>import('./views/newUserCenter/addressList.vue'),
          meta: {
            title: '收获地址'
          }
        }, {
          path: 'addAndEditAddress',
          component: ()=>import('./views/newUserCenter/addAndEditAddress.vue'),
          meta: {
            title: '添加地址'
          }
        }, {
          path: 'search',
          component: ()=>import('./views/newUserCenter/search.vue'),
          meta: {
            title: '搜索'
          }
        },{
          path:'userCenterCoupon',
          component: ()=>import("./views/newUserCenter/userCenterCoupon.vue"),
          meta: {
              title: '我的优惠券',
          }
        },{
          path:'complaintCenter',
          component: ()=>import("./views/newUserCenter/complaintCenter.vue"),
          meta: {
              title: '投诉中心',
          }
        },{
          path:'complaintSubmit',
          component: ()=>import("./views/newUserCenter/complaintSubmit.vue"),
          meta: {
              title: '提交投诉',
          }
        },{
          path:'complaintRecord',
          component: ()=>import("./views/newUserCenter/complaintRecord.vue"),
          meta: {
              title: '投诉记录',
          }
        },{
          path:'complaintDetail',
          component: ()=>import("./views/newUserCenter/complaintDetail.vue"),
          meta: {
              title: '投诉详情',
          }
        }
      ]
    } 

  ]
})
